var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m43.886 41.68-9.171-21.988a2.446 2.446 0 0 0-.876-1.21A2.477 2.477 0 0 0 32.417 18h-.811c-.513.01-1.01.178-1.422.482a2.446 2.446 0 0 0-.876 1.21l-3.99 9.58h-3.019c-.434.003-.85.174-1.159.478a1.632 1.632 0 0 0-.486 1.148v.022c.004.431.178.844.486 1.148.308.304.725.476 1.16.477h1.621l-3.807 9.135c-.072.2-.11.41-.113.623-.017.452.145.892.452 1.226a1.584 1.584 0 0 0 1.218.469c.34-.005.671-.114.947-.312a1.99 1.99 0 0 0 .653-.825l4.186-10.313h2.908a1.665 1.665 0 0 0 1.16-.478 1.63 1.63 0 0 0 .485-1.147v-.045a1.633 1.633 0 0 0-.486-1.148 1.659 1.659 0 0 0-1.159-.477h-1.552l3.197-7.91 8.72 21.518c.138.328.364.613.652.825.276.198.607.307.947.312a1.594 1.594 0 0 0 1.218-.469 1.71 1.71 0 0 0 .452-1.226 1.462 1.462 0 0 0-.113-.623Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVAave);
export default __webpack_public_path__ + "static/media/vAave.2017b7f033da8044c415dd2759927dd2.svg";
export { ForwardRef as ReactComponent };